import React, { useMemo } from "react";
import { ICommenterImgProps } from "./CommenterImg.types";
import { DEFAULT_USER_PROFILE_IMG_SRC } from "../../../../../assets/user";
import { styles } from "./Comment.styles";
import { USER_AVATAR_PREFERENCE } from "./constants/CommenterImg.constants";
import { generateUniqueColorBasedOnKey } from "../../../../../features/Common/modules/Color/utils/generateUniqueColorBaseOnKey";

const CommenterImg = ({
  avatarPreference,
  userDetails,
}: ICommenterImgProps) => {
  const backgroundColor = useMemo(
    () => generateUniqueColorBasedOnKey(userDetails.username),
    [userDetails.username],
  );
  switch (avatarPreference) {
    case USER_AVATAR_PREFERENCE.PROFILE_PICTURE:
      return (
        <img
          src={userDetails?.profilePic || DEFAULT_USER_PROFILE_IMG_SRC}
          width={44}
          height={44}
          className={styles.img}
        />
      );
    case USER_AVATAR_PREFERENCE.NAME_INITIALS:
      return (
        <div
          className={styles.commenterAlphabetIcon}
          style={{ backgroundColor: backgroundColor }}
        >
          {userDetails?.initials}
        </div>
      );
    default:
      return null;
  }
};

export default CommenterImg;
